// Variant Ingredients Custom Element
var VariantIngredients = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this._form = document.forms[this.getAttribute("form")];

    if (this._form) {
      // Listen for variant changes
      this._form.addEventListener("variant:change", this._onVariantChanged.bind(this), { signal: this._abortController.signal });

      // Handle initial page load
      this._getInitialVariantId();
    } else {
      console.warn('VariantIngredients: Missing form');
    }
  }

  disconnectedCallback() {
    this._abortController?.abort();
  }

  _onVariantChanged(event) {
    if (event.detail.variant && event.detail.variant.id) {
      this._updateIngredientsByVariantId(event.detail.variant.id);
    }
  }

  _getInitialVariantId() {
    const formId = this.getAttribute('form');
    const variantPicker = document.querySelector(`variant-picker[form-id="${formId}"]`);

    if (!variantPicker) return;

    const variantDataScript = variantPicker.querySelector('script[data-variant]');
    if (!variantDataScript) return;

    try {
      const currentVariant = JSON.parse(variantDataScript.textContent);
      if (currentVariant && currentVariant.id) {
        this._updateIngredientsByVariantId(currentVariant.id);
      }
    } catch (e) {
      console.warn('VariantIngredients: Failed to parse initial variant data:', e);
    }
  }

  _updateIngredientsByVariantId(variantId) {
    // Hide all variant content blocks
    const allContentBlocks = this.querySelectorAll('.variant-ingredients-content');
    allContentBlocks.forEach(block => {
      block.style.display = 'none';
    });

    // Show the content block for the current variant
    const currentContentBlock = this.querySelector(`.variant-ingredients-content[data-variant-id="${variantId}"]`);
    const accordionDetails = this.querySelector('details');

    if (currentContentBlock) {
      currentContentBlock.style.display = 'block';
      if (accordionDetails) {
        accordionDetails.style.display = 'block';
      }
    } else {
      // Hide the accordion if no ingredients exist for this variant
      if (accordionDetails) {
        accordionDetails.style.display = 'none';
      }
    }
  }
};

if (!window.customElements.get("variant-ingredients")) {
  window.customElements.define("variant-ingredients", VariantIngredients);
}
